<template>
<div>

  <van-pull-refresh v-model="loading" @refresh="getDetailInfo">
    <div class="medicine-advice-detail-container" v-if="detailData">
      <!-- 建议状态 begin -->
      <div class="advice-status item-card">
        <div>{{formatAdviceType}}-{{formatAdviceStatus}}</div>
        <div class="reason mt-8" v-if="detailData.status == 5">退款原因：{{detailData.refundReason}}</div>
        <div class="reason mt-8" v-if="detailData.status == 7">失效原因：{{detailData.invalidReason}}</div>
        <div class="reason mt-8" v-if="detailData.status == 6">原因：{{detailData.convertFailReason}}</div>
      </div>
      <!-- 建议状态 end -->
      <!-- 门店信息 -->
      <div class="item-card store-box" v-if="storeAndCode.shopId">
        <div class="title-text mb-12">门店信息</div>
        <div class="advice-info">
          <div>
            <div class="store-add">{{storeAndCode.shopName}}</div>
            <div class="store-km">距你：{{storeAndCode.distance}}</div>
          </div>
          <div>
            <div class="property">营业时间：</div>
            <div class="value">{{storeAndCode.openingHours}}</div>
          </div>
        </div>
      </div>
      <!-- 二维码信息 -->
      <div class="item-card code-box" v-if="storeAndCode.qrCodeStore">
        <div class="title-text mb-12">用药建议二维码 <span class="tit-right">到店后出示给店员扫码</span></div>
        <div class="advice-info">
          <img class="code-url" :src="storeAndCode.qrCodeStore" alt="">
        </div>
      </div>
      <!-- 建议信息 begin -->
      <div class="item-card">
        <div class="title-text mb-12">分享信息</div>
        <div class="advice-info">
          <div>
            <div class="property">就诊人：</div>
            <div class="value txt-ellipsis-2">{{detailData.name}}，{{detailData.patientPhone}}</div>
          </div>
          <div>
            <div class="property">分享医生：</div>
            <div class="value">{{detailData.doctorName}}</div>
          </div>
          <div>
            <div class="property">分享时间：</div>
            <div class="value">{{detailData.createDate}}</div>
          </div>
          <div v-if="(detailData.shareType !==1 || detailData.status != 6) && detailData.shareType !==5">
            <div class="property" v-if="!detailData.exchangeFlag">用药诊断：</div>
            <!-- 此处暂时设置为超出两行显示省略号，根据需要调整类 -->
            <div class="value txt-ellipsis-2" v-if="!detailData.exchangeFlag">{{detailData.diagnosis}}</div>
          </div>
          <div v-if="(detailData.shareType !==1 || detailData.status != 6) && detailData.shareType !==5">
            <div class="property" v-if="!detailData.exchangeFlag">用药类型：</div>
            <div class="value" v-if="!detailData.exchangeFlag">{{detailData.rxType == 0 ? '西药' : '中药' }}</div>
          </div>
        </div>
      </div>
      <!-- 建议信息 end -->

      <!-- 建议详情 begin -->
      <!-- 药品清单 -->
      <div class="item-card" v-if="!(detailData.shareType ==1 && detailData.exchangeFlag)">
        <div v-if="detailData.shareType == 5" class="title-text">商品清单</div>
        <div v-else class="title-text">药品清单</div>
        <!-- 中药， 这期先不做-->
        <!-- <template v-if="detailData.rxType == 0">
          <div class="drug-list mt-8 pb-8">
            <div class="drug-item-Chinese" v-for="item in detailData.shareMedicineVOList" :key="item">
              <span>{{item.name}}&nbsp;</span>
              <span class="drug-weight">{{item.weight}}<span v-if="item.cookType">({{item.cookType}})</span></span>
            </div>
          </div>
          <div class="drug-list-item">
            <div class="text">用法用量：</div>
            <div>共{{item.total}}{{item.totalDesc}}，每日{{drug.singleDoseNum}}{{drug.singleDoseUnitDesc}}，{{item.medicineUsageDesc}}</div>
          </div>
          <div class="drug-list-item">
            <div class="text">医生嘱咐：</div>
            <div>浸泡30分钟，再煮40分钟，口服，每日2次，一剂饭后服</div>
          </div>
        </template> -->
        <!-- 西药 -->
        <div>
          <div class="drug-list mt-16 pb-16">
            <div class="drug-item-western" v-for="item in detailData.shareMedicineVOList" :key="item.medicineCode">
              <!-- 药品名及数量 -->
              <div class="drug-item-top">
                <div class="drug-name-group">
                  <div class="point">·</div>
                  <div class="drug-name">
                    {{item.medicineName}}
                  </div>
                </div>
                <!-- 模板分享，可编辑数量 -->
                <div class="medicine-info" v-if="(detailData.shareType == 3 && detailData.status == 2 && detailData.payMode != 2)">
                  <img @click="handleDrugNumDecrease(item)" class="num-add" src="https://dsl-ds.oss-cn-shenzhen.aliyuncs.com/C5F1BCD6FDF247948B44298195A63CF1.png" />
                  <div class="medicine-num">{{item.actualQuantity || item.total}}</div>
                  <img @click="handleDrugNumAdd(item)" class="num-decrease" src="https://dsl-ds.oss-cn-shenzhen.aliyuncs.com/E735715CA1FA4DA59A97E7959E2D03FE.png" />
                  <div class="medicine-desc">{{item.totalDesc || ''}}</div>
                </div>
                <div class="quantity" v-else>x{{item.total}}</div>
              </div>
              <!-- 厂家 -->
              <div v-if="detailData.shareType == 5" class="drug-item-row mt-8">厂家：{{item.medicineFactory}}</div>
              <!-- 规格 -->
              <div class="drug-item-row mt-8">规格：{{item.specification}}</div>
              <!-- 用法用量 -->
              <div v-if="detailData.shareType != 5" class="drug-item-row mt-4">用法用量：{{item.usageDescribe}}</div>
              <!-- 医生嘱咐 -->
              <div v-if="detailData.shareType != 5" class="drug-item-row mt-4">医生嘱咐：{{item.doctorAdvice}}</div>
            </div>
          </div>
          <div class="packages" v-if="detailData.shareType == 6  && detailData.packageNum">
            共 {{detailData.packageNum}} 件
          </div>
        </div>
        <!-- 总价 -->
        <div class="total-price">
            <!-- 易健康模板，暂时去掉参考总价，后端接口参考总价计算错误 -->
            <div class="reference-price" v-if="detailData.referencePrice && detailData.referencePrice != 0 && detailData.shareType != 6">
              <div class="reference-text">参考总价：</div>
              <div class="price">￥{{detailData.referencePrice}}</div>
            </div>
            <div class="real-pay-price" v-if="detailData.actualTotal">
              <div class="real-pay-text">实付金额：</div>
              <div class="real-pay-unit">￥</div>
              <div class="price">{{detailData.actualTotal || ''}}</div>
            </div>
        </div>
      </div>
      <!-- 建议详情 end -->

      <!-- 处方图片 -->
      <div class="item-card" v-if="detailData.rxImg">
        <div class="title-text mb-16">处方图片</div>
        <img class="prescription-img" :src="detailData.rxImg" alt="" @click="showPictures">
      </div>

      <div v-if="detailData.shareType ==1 && detailData.exchangeFlag" class="tips tips-list">处方正在识别中，请稍等~</div>
    </div>
    <div v-if="showTips" class="tips">获取用药建议详情失败，下拉刷新试试~</div>
  </van-pull-refresh>
    <!-- 底部按钮 -->
    <div class="footer" v-if="detailData && !(detailData.shareType ==1 && detailData.exchangeFlag) && (!detailData.payMode || detailData.payMode!=2)">
      <!-- <div class="btn-1" v-if="detailData.status == 1" @click="toNami(0)">立即领取</div> -->
      <div class="btn-1 btn-store" v-if="detailData.showStorePay == 1" @click="routerStoreAndCode">到店支付</div>
      <div class="btn-1" v-if="detailData.status == 2" @click="toNami(1)">去下单</div>
      <div class="btn-1" v-if="detailData.status == 3" @click="toNami(2)">去支付</div>
      <div class="btn-1" v-if="[4, 5, 8].includes(detailData.status)" @click="toNami(2)">查看订单</div>
    </div>
</div>
</template>

<script>
import { updateMedicineNumber, getDetail, getStoreAndQrCode } from '@/api/advice';
import { ImagePreview, Toast } from 'vant';

import { formatAdviceStatus, formatAdviceType } from '@/common/js/computed';
import baseConfig from '@/api/baseConfig';
import bridgeService from '@/lib/dsbridgeService';
import Lodash from 'lodash';

export default {
  data() {
    return {
      loading: false,
      images: [],
      detailData: null,
      showTips: false,
      storeAndCode: {},
    };
  },
  computed: {
    formatAdviceStatus() {
      return formatAdviceStatus(this.detailData.status);
    },
    formatAdviceType() {
      return formatAdviceType(this.detailData.shareType);
    },
  },
  methods: {
    showPictures() {
      ImagePreview({
        images: [this.detailData.rxImg],
        closeable: true,
      });
    },
    async getDetailInfo() {
      this.loading = true;
      const shareId = this.$route.query.shareId || '';
      const res = await getDetail(shareId);
      if (res && res.success) {
        this.loading = false;
        this.detailData = res.data;
        // 判断是否展示门店信息
        if (res.data.status === 2 || res.data.status === 3 || res.data.status === 100) {
          // 处理门店以及二维码数据
          if (res.data.payMode === 2) {
            this.getDetailStoreAndCode();
          }
        } else {
          this.storeAndCode = {};
        }
      } else {
        this.showTips = true;
      }
    },
    async routerStoreAndCode() {
      // 待下单状态，模板分享，提前调用预下单
      if ([3, 6].includes(this.detailData.shareType) && this.detailData.status === 2) {
        await this.handleConfirmShareDrugs();
      }
      this.getDetailStoreAndCode();
    },
    // 处理门店以及二维码数据，页面上面直接根据有无此数据来判断是否展示
    getDetailStoreAndCode() {
      const { shareId, shopId, } = this.detailData;
      bridgeService.requestLocation((res) => {
        console.log('获取APP位置信息', res);
        getStoreAndQrCode({
          shareId,
          shopId,
          lng: res ? res.longitude : '',
          lat: res ? res.latitude : '',
        }).then((coderes) => {
          if (coderes && coderes.success) {
            console.log('门店以及二维码', coderes);
            this.storeAndCode = coderes.data;
            this.detailData.payMode = 2;
          } else {
            this.storeAndCode = {};
          }
        });
      });
    },
    // eslint-disable-next-line func-names
    toNami: Lodash.debounce(async function (flag) {
      let path = '';
      let query = `bizData=${this.detailData.shareId}&bizType=5&shareType=${this.detailData.shareType}`;
      if (flag === 1) {
        // 待下单状态，模板分享，提前调用预下单
        if ([3, 6].includes(this.detailData.shareType) && this.detailData.status === 2) {
          await this.handleConfirmShareDrugs();
        }
        console.log('query', query);
        // 跳转至去下单
        path = `${baseConfig.namiUrl}advanceExpert?${query}`;
        window.location.href = path;
      } else if (flag === 2) {
        // 跳转至查看详情
        query = `orderNumber=${this.detailData.orderNumber}&fromPage=hospital`;
        path = `${baseConfig.namiUrl}orderDetail?${query}`;
        window.location.href = path;
      }
    }, 800),
    // 模板分享，预下单
    async handleConfirmShareDrugs() {
      // 修改用药建议药品数量
      const medicineParams = this.detailData.shareMedicineVOList.map((item) => {
        const param = {
          id: item.id,
          actualQuantity: item.actualQuantity,
          shareId: this.detailData.shareId,
          shareType: this.detailData.shareType,
        };
        if (param.shareType === 6) {
          param.actualQuantity = item.total * this.detailData.packageNum;
        }
        return param;
      });
      console.log('medicineParams', medicineParams);
      const { code, msg, } = await updateMedicineNumber(medicineParams);
      if (code !== 200 && msg) {
        Toast(msg);
      }
    },
    // 增加模板分享药品数量
    handleDrugNumAdd(item) {
      const { actualQuantity, total, } = item;
      const num = actualQuantity || total;
      item.actualQuantity = num + 1;
      item.total = num + 1;
    },
    // 减少模板分享药品数量
    handleDrugNumDecrease(item) {
      const { actualQuantity, total, } = item;
      const num = actualQuantity || total;
      // 数量最小减到1
      if (num <= 1) {
        return false;
      }
      item.actualQuantity = num - 1;
      item.total = num - 1;
    },
  },
  created() {
    this.getDetailInfo();
  },
};
</script>

<style lang="scss" scoped>
.medicine-advice-detail-container {
  padding-bottom: 104px;
}

.tips {
  color: #999;
  font-size: 14px;
  margin-top: 10px;
  text-align: center;
}

.tips-list {
  margin-top: 40px;
}

.advice-status {
  font-weight: 600;

  .reason {
    @include font (15px, 23px, #666666);

    font-weight: 400;
  }
}

.item-card {
  @include font (18px, 25px, #1F2229);

  margin-bottom: 8px;
  padding: 16px;
  background-color: #fff;
  box-sizing: border-box;
}

.medicine-info {
  display: flex;
  align-items: center;
  margin-left: 10px;

  .medicine-num {
    margin: auto 8px;
  }

  .num-add,
  .num-decrease {
    width: 20px;
    height: 20px;
  }

  .medicine-desc {
    margin-left: 10px;
  }
}

.title-text {
  @include font (18px, 25px, #1F2229);

  font-weight: 600;
}

.advice-info {
  & > div {
    display: flex;
    margin-bottom: 8px;

    .property {
      @include font (16px, 24px, #666666);

      width: 90px;
      flex-shrink: 0;
      text-align: right;
    }

    .value {
      @include font (16px, 24px, #1F2229);
    }
  }

  & > div:last-child {
    margin-bottom: 0;
  }
}

.drug-list-item {
  display: flex;
  padding: 16px 0;
  border-bottom: 1px solid #e6e6e6;
}

.prescription-img {
  width: 54px;
  height: 72px;
}

.text {
  @include font (16px, 24px, #222222);

  font-weight: 500;
  flex-shrink: 0;
}

.reference-price {
  @include flex (baseline, flex-end);

  padding-top: 20px;

  .reference-text {
    @include font (14px, 20px, #222222);
  }

  .reference-unit {
    @include font (12px, 17px, #222222);
  }

  .price {
    @include font (16px, 17px, #222222);
  }
}

.real-pay-price {
  @include flex (baseline, flex-end);

  margin-top: 8px;

  .real-pay-text {
    @include font (14px, 20px, #222222);
  }

  .real-pay-unit {
    @include font (12px, 20px, #FE6602);
  }

  .price {
    @include font (20px, 20px, #FE6602);
  }
}

.drug-list {
  border-bottom: 1px solid #e6e6e6;

  .drug-item-Chinese {
    @include font (16px, 24px, #222222);

    display: inline-block;
    padding: 8px 0;
    width: 50%;
    box-sizing: border-box;

    .drug-weight {
      @include font (16px, 24px, #666666);
    }
  }

  .drug-item-western {
    @include font (14px, 22px, #666666);

    margin-top: 24px;
  }

  .drug-item-western:first-child {
    margin-top: 0;
  }
}

.drug-item-top {
  @include flex (flex-start, space-between);

  .drug-name-group {
    @include flex (flex-start, flex-start);
    @include font (16px, 24px, #1F2229);

    width: 282px;
    font-weight: 600;

    .point {
      width: 8px;
    }
  }

  .quantity {
    @include font (16px, 22px, #1F2229);
  }
}

.drug-item-row {
  width: 282px;
}

.txt-ellipsis-2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.store-box {
  .value {
    color: #3cb979 !important;
  }

  .store-add {
    flex: 1;
    font-size: 16px;
    color: #1f2229;
    line-height: 22px;
  }

  .store-km {
    font-size: 13px;
    color: #666;
    line-height: 22px;
  }

  .property {
    width: auto !important;
  }
}

.code-box {
  .title-text {
    display: flex;
  }

  .tit-right {
    font-size: 14px;
    color: #666;
    margin-left: 8px;
    font-weight: normal !important;
  }

  .advice-info {
    text-align: center;
  }

  .code-url {
    width: 178px;
    height: 178px;
  }
}

.footer {
  display: flex;

  @include fixed-bottom(10px, 15px, 10px, 15px);

  .btn-1 {
    @include font(17px, 50px, #fff, center);

    flex: 1;
    height: 50px;
    padding: 0 15px;
    border-radius: 25px;
    background: linear-gradient(151deg, #42e9a4 0%, #01bb6e 100%);
  }

  .btn-store {
    margin-right: 15px;
    background: #ebfaf4;
    color: $brand-color;
    border: 1px solid $brand-color;
    box-sizing: border-box;
  }
}

.packages {
  text-align: right;
  margin-top: 10px;
  margin-right: 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666;
  line-height: 20px;
}
</style>
